import React, { useState, useEffect } from 'react'

export default function QuantumLogo() {
    const [items, setItems] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0)
    const [isFading, setIsFading] = useState(false)

    useEffect(() => {
        const loadData = async () => {
            try {
                const res = await fetch(`/images/logos/logos_and_mottos.json?v=${Date.now()}`)
                const data = await res.json()

                const { jpg_files = [], mottos = [] } = data
                const maxPairs = Math.max(jpg_files.length, mottos.length)

                // Pair images and mottos, reusing the shorter list if needed
                const combined = Array.from({ length: maxPairs }).map((_, i) => ({
                    src: `/images/logos/${jpg_files[i % jpg_files.length]}`,
                    caption: mottos[i % mottos.length],
                }))

                setItems(combined)
                setCurrentIndex(Math.floor(Math.random() * combined.length)) // Start with a random one
            } catch (err) {
                console.error('Failed to load logo and motto data:', err)
            }
        }

        loadData()
    }, [])

    const handleClick = () => {
        if (items.length <= 1) return

        let newIndex
        do {
            newIndex = Math.floor(Math.random() * items.length)
        } while (newIndex === currentIndex)

        const next = items[newIndex]

        // Preload image first
        const img = new Image()
        img.src = next.src
        img.onload = () => {
            setIsFading(true)
            setTimeout(() => {
                setCurrentIndex(newIndex)
                setIsFading(false)
            }, 200) // Duration should match your CSS
        }
    }


    const current = items[currentIndex]
    if (!current) return null

    return (
        <div className="quantum-logo" role="img" aria-label={current.caption}>
            <img
                src={current.src}
                alt={current.caption}
                className={`quantum-logo-img ${isFading ? 'fade-out' : 'fade-in'}`}
                onClick={handleClick}
                style={{ cursor: items.length > 1 ? 'pointer' : 'default' }}
            />
            <div className="quantum-logo-caption" aria-hidden="true">
                {current.caption}
            </div>
        </div>
    )
}
